var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-btn',{attrs:{"block":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.dialog = true}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" "),_c('BidDialog',{attrs:{"product":_vm.product},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }